export default {
  INITIAL: "INITIAL",
  UPLOADING: "UPLOADING",
  HAS_UPLOAD: "HAS_UPLOAD",
  HAS_ERROR: "HAS_ERROR",
};
